import { SMLRouteNames } from '../../../routing/sml/SMLRoutes';

// eslint-disable-next-line no-control-regex -- the test is for control characters
const CONTROL_CHARACTER = /[\u0000-\u001f\u007f]/;

/**
 * The `?from=` of the plans page, when it is a path of this app: it starts with one slash (no
 * `//host`, no scheme), holds no control character (a browser drops a tab or a newline, so
 * `/\t/evil.com` becomes `//evil.com`) and is not the plans page itself. Anything else is `null`,
 * so Back can never leave the app.
 */
export function safeReturnPath(from: string | null): string | null {
  if (
    from === null ||
    !from.startsWith('/') ||
    from.startsWith('//') ||
    from.includes('\\') ||
    CONTROL_CHARACTER.test(from)
  ) {
    return null;
  }
  const firstSegment = from.slice(1).split(/[/?#]/)[0];
  return firstSegment === SMLRouteNames.plans ? null : from;
}
